import { RAVEN_EVENTS_AI, RAVEN_EVENTS_PROBLEM, RAVENS_EVENTS_GEOFENCE, RAVENS_EVENTS_GESTURE, RAVENS_EVENTS_PARKED, RAVENS_EVENTS_REMOTE, RAVENS_EVENTS_SPEEDING } from "../common/EventsUtils";

export const RUNTIME_MAP_FEATURES = {
    VEHICLE_MARKER_PREFIX: "RUNTIME_ONLY_VEHICLE_MARKER", // Do not add sprites/image assets in Mapbox Studio with this same prefix!
    VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX: "-WITH_MULTIPLE_OCCUPANTS"
}

export const MARKER_STATES = {
    PROBLEM: "problem",
    PROBLEM_SELECTED: "problem-selected",
    PARKED: "parked",
    PARKED_SELECTED: "parked-selected",
    IDLING: "idling",
    SELECTED: "selected",
    DRIVING: "driving",
    ASSET: "asset",
    ASSET_SELECTED: "asset-selected",
}

export const EVENT_CATEGORY_NAMES = {
    ALERT: "alert",
    GESTURE: "gesture",
    PROBLEM: "problem",
    PARKED: "parked",
    REMOTE: "remote",
    SPEEDING: "speeding",
    GEOFENCE: "geofence",
    AI: "ai-event",

    FOR_EVENT_TYPE(protobufNameString) {
        if (RAVENS_EVENTS_SPEEDING.includes(protobufNameString)) {
            return EVENT_CATEGORY_NAMES.SPEEDING;
        } else if (RAVEN_EVENTS_PROBLEM.includes(protobufNameString)) {
            return EVENT_CATEGORY_NAMES.PROBLEM;
        } else if (RAVEN_EVENTS_AI.includes(protobufNameString)) {
            return EVENT_CATEGORY_NAMES.AI;
        } else if (RAVENS_EVENTS_GESTURE.includes(protobufNameString)) {
            return EVENT_CATEGORY_NAMES.GESTURE;
        } else if (RAVENS_EVENTS_PARKED.includes(protobufNameString)) {
            return EVENT_CATEGORY_NAMES.PARKED;
        } else if (RAVENS_EVENTS_REMOTE.includes(protobufNameString)) {
            return EVENT_CATEGORY_NAMES.REMOTE;
        } else if (RAVENS_EVENTS_GEOFENCE.includes(protobufNameString)) {
            return EVENT_CATEGORY_NAMES.GEOFENCE;
        } else {
            return EVENT_CATEGORY_NAMES.ALERT;
        }
    }
}

export const EVENT_CATEGORY_IDS = {
    ALERT: 1,
    GESTURE: 2,
    PROBLEM: 3,
    PARKED: 4,
    REMOTE: 5,
    SPEEDING: 6,
    GEOFENCE: 7,
    AI: 8,

    FOR_EVENT_TYPE(protobufNameString) {

        switch (EVENT_CATEGORY_NAMES.FOR_EVENT_TYPE(protobufNameString)) {
            case EVENT_CATEGORY_NAMES.ALERT: return EVENT_CATEGORY_IDS.ALERT; // most common/default category type
            case EVENT_CATEGORY_NAMES.GESTURE: return EVENT_CATEGORY_IDS.GESTURE;
            case EVENT_CATEGORY_NAMES.PROBLEM: return EVENT_CATEGORY_IDS.PROBLEM;
            case EVENT_CATEGORY_NAMES.PARKED: return EVENT_CATEGORY_IDS.PARKED;
            case EVENT_CATEGORY_NAMES.REMOTE: return EVENT_CATEGORY_IDS.REMOTE;
            case EVENT_CATEGORY_NAMES.SPEEDING: return EVENT_CATEGORY_IDS.SPEEDING;
            case EVENT_CATEGORY_NAMES.GEOFENCE: return EVENT_CATEGORY_IDS.GEOFENCE;
            case EVENT_CATEGORY_NAMES.AI: return EVENT_CATEGORY_IDS.AI;
        }
        console.error("mapboxMapDashboardConstants configuration error. Unknown EVENT_CATEGORY_NAME constant assigned to event. Returning default EVENT_CATEGORY_IDS.ALERT for event name " + protobufNameString);
        return EVENT_CATEGORY_IDS.ALERT; // most common/default category type
    }
}
